import { UserSession } from '@esri/arcgis-rest-auth';
import AuthService from '../../shared/authService';
import ConfigService from '../../shared/configService';
import { useHistory } from "react-router-dom";

const CompleteAuth = () => {

    const history = useHistory();

    const completeAuth = async (): Promise<void> => {
        try {
            const session = UserSession.completeOAuth2({
                clientId: ConfigService.getConfig().agol.authentification.clientId,
                redirectUri: ConfigService.getConfig().agol.authentification.redirectUri
            });

            await AuthService.getInstance().initSession(session);

            history.push(ConfigService.getConfig().routes?.submissionTool.reports || '');
        }
        catch(err: any) {
            console.log(err)
        }
    }
    
    completeAuth();

    return (
        <div>...</div>
    )
}

export default CompleteAuth;